import styled from "@emotion/styled";
import { TableCell, Button } from "@mui/material";

import InnoIcons from "InnoUI/innoicons";
import theme from "theme";

const WestIcon = styled(InnoIcons.WestIcon)`
  color: ${theme.colors.white};
  font-size: 20px;
  border-radius: 4px;
  margin-right: 5px;
  width: 18px;
  height: 18px;
  background: linear-gradient(
    90deg,
    rgba(82, 107, 173, 1) 0%,
    rgba(0, 170, 255, 1) 100%
  );
`;

const TableCellContiner = styled(TableCell)`
  padding: 3px;
  text-align: center;
  color: black;
`;
const divcontainer = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 0px 0px;
`;
const TableCellContiner2 = styled(TableCell)`
  padding: 0px;
  text-align: center;
  font-size: 12px;
  margin: 0px;
`;
const buttoncontainer = styled(Button)`
  border-radius: 4px;
  margin: 0 8px;
`;
const spancontainer = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 3px;
`;

const Moveto = styled.span`
  font-size: 13px;
  font-weight: bold;
`;
const Paginationcontainer = styled.div`
  margin-top: 16px;
  text-align: center;
`;

const LoaderContainer = styled.div`
  min-height: 400px;
  position: relative;
`;
const LoderCommonContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 120%;
  transform: translate(-50%, -50%);
`;

const divcontainer2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  height: 10px;
`;

const spancontainer2 = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  cursor: pointer;
`;
const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 40%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 30px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid #eb7909;
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;

const SC = {
  WestIcon,
  TableCellContiner,
  divcontainer,
  TableCellContiner2,
  buttoncontainer,
  spancontainer,
  Moveto,
  Paginationcontainer,
  LoaderContainer,
  LoderCommonContainer,
  divcontainer2,
  spancontainer2,
  InputContiner,
  SearchIcon,
  InputStyle,
};
export default SC;
